
{
  "title": {
    "single": "Our location",
    "multi": "Our locations"
  }
}
